import { useState, useMemo } from "react";
import { Avatar, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { getS3URL, isBlobURL, isValidURL } from "../../utills/common";

const { Text } = Typography;

export default function UXAvatar({
  text = "",
  logo = "",
  size = 24,
  userId = 0,
  isRect = false,
  fontSize = "14px",
  useHoverEffect = false,
}) {
  const [hovered, setHovered] = useState(false);

  const borderRadius = isRect ? "4px" : "50%";
  const previewUrl = isBlobURL(logo) || isValidURL(logo) ? logo : getS3URL(logo);

  // Get the background color based on the first letter of the text
  const background = useMemo(() => {
    const colors = ["#FF7D52", "#FFC107", "#4CAF50", "#2196F3", "#9C27B0", "#FF5722", "#795548"];

    // If random color is enabled, return a random color
    if (userId) {
      const assignedColor = localStorage.getItem(`color-${userId}`) || "";
      const color = assignedColor || colors[Math.floor(Math.random() * colors.length)];

      // Store the color
      if (!assignedColor) localStorage.setItem(`color-${userId}`, color);

      return color;
    }

    const charCode = text.charCodeAt(0);
    const colorIndex = charCode % colors.length;

    return colors[colorIndex];
  }, [text, userId]);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`UXAvatarContainer ${useHoverEffect && hovered ? "hovered" : ""}`}
    >
      {logo ? (
        <Avatar size={size} src={previewUrl} className='avatar bg-transparent' />
      ) : (
        <Avatar size={size} style={{ lineHeight: 1, fontWeight: 600, background, borderRadius }} className='avatar'>
          <Text strong style={{ fontSize, color: "#ffffff", textTransform: "uppercase" }}>
            {text}
          </Text>
        </Avatar>
      )}

      {useHoverEffect && hovered && <EditOutlined className='edit-icon' />}
    </div>
  );
}
